import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosBuzzOne } from '../../../../axios';
import {
  allEmployeeRoute,
  employeeRoute,
  updateUserRoute,
} from '../../utils/apiRoutes';
import { moduleName } from '../../module';

export const createBccUserAsync = createAsyncThunk(
  `${moduleName}/createBccUserAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'POST',
      url: employeeRoute(),
      data: payload,
      headers: { 'x-user-type': 'BCC' },
    });
    const data = response.data;
    return data;
  }
);

export const updateBccUserAsync = createAsyncThunk(
  `${moduleName}/updateBccUserAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'PUT',
      url: updateUserRoute(payload.id),
      data: payload.data,
      headers: { 'x-user-type': 'BCC' },
    });
    const data = response.data;
    return data;
  }
);

export const getAllBccUserAsync = createAsyncThunk(
  `${moduleName}/getAllBccUserAsync`,
  async (payload) => {
    const { params } = payload;
    const response = await axiosBuzzOne({
      method: 'GET',
      url: allEmployeeRoute(),
      params: { ...params },
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

const BccUserSlice = createSlice({
  name: `${moduleName}/bccUser`,
  initialState: {
    loading: false,
    bccUser: null,
    bccAllUser: null,
  },
  reducers: {},
  extraReducers: {
    // create bcc user using POST api
    [createBccUserAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [createBccUserAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.bccUser = action.payload;
    },
    [createBccUserAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    // update bcc user
    [updateBccUserAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [updateBccUserAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [updateBccUserAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    // get all data
    [getAllBccUserAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getAllBccUserAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.bccAllUser = action.payload;
    },
    [getAllBccUserAsync.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export default BccUserSlice.reducer;
